import { useContext } from 'react'
import { useIntl } from 'react-intl'

import ItemPriceAndCTAs from '../common/ItemPriceAndCTAs'
import type { DetailItemCardVariant } from '../common/types'

import type {
  TourItem,
} from 'tripPlanner/types/tripItem'
import { getItineraryDaysCount } from '../utils'
import TourV2OfferCardPriceDetails from 'tripPlanner/components/ItemOfferPrice/TourV2PriceDetails'
import useCheapestOfTourV2Offer from 'hooks/TourV2/useCheapestOfTourV2Offer'
import GeoContext from 'contexts/geoContext'
import TourCTAContent from '../CTAContent/TourCTAContent'
import { buildProductLink } from 'tripPlanner/utils/bookmark/restoreCart'
import StatusLabel from 'LuxKit/Label/StatusLabel'

interface Props {
  item: Utils.RequiredProp<TourItem, 'savedItemData'>
  offer: App.Tours.TourV2Offer
  variant: DetailItemCardVariant
}

function TourV2PriceAndCTAs({ item, offer, variant }: Props) {
  const intl = useIntl()
  const { currentCurrency } = useContext(GeoContext)
  const { cheapestPurchasableOption, cheapestVariation } =
    useCheapestOfTourV2Offer(offer)

  if (item.isSuggested) {
    // We don't currently do suggested tours. If we ever do, update this.
    return null
  }

  const offerLink = buildProductLink(item, { offer }) ?? ''

  const isOfferAvailable = !!(cheapestPurchasableOption && cheapestVariation)

  const priceAreaContent =
    cheapestPurchasableOption && cheapestVariation ?
        <TourV2OfferCardPriceDetails
          depositComponent={null}
          purchasableOption={cheapestPurchasableOption}
          duration={getItineraryDaysCount(cheapestVariation)}
          currencyCode={currentCurrency}
        /> :
        <StatusLabel variant="cancelled">
          {intl.formatMessage({
            id: 'durj1t-q914Rw-pc23qb',
            defaultMessage: 'Sold Out',
            description: 'Status label shown when a tour offer is no longer available for purchase',
          })}
        </StatusLabel>

  const ctaAreaContent = (
    <TourCTAContent
      item={item}
      isOfferAvailable={isOfferAvailable}
      variant={variant}
      offerLink={offerLink}
    />
  )

  return (
    <ItemPriceAndCTAs>
      {priceAreaContent && <div className="price-area">{priceAreaContent}</div>}
      {ctaAreaContent && <div className="cta-area">{ctaAreaContent}</div>}
    </ItemPriceAndCTAs>
  )
}

export default TourV2PriceAndCTAs
